<!--
 * @Date: 2026-05-18
 * @Description: 通用强制阅读协议弹窗组件
 *              - 弹窗展示协议内容
 *              - 强制阅读7秒
 *              - 必须滚动到最底部
 *              - 点击确定才算真正勾选
-->
<template>
  <van-popup
    v-model="showPopup"
    position="bottom"
    round
    :close-on-click-overlay="false"
    :style="{ height: '70%' }"
  >
    <div class="agreement-popup">
      <!-- 标题 -->
      <div class="popup-header">
        <h3>{{ title }}</h3>
        <van-icon name="cross" @click="handleClose" />
      </div>
      
      <!-- 阅读计时器 -->
      <!-- <div class="read-timer" v-if="!canConfirm">
        <span class="timer-text">请阅读完毕（剩余 {{ countdown }} 秒）</span>
        <div class="timer-progress">
          <div class="timer-bar" :style="{ width: progressWidth + '%' }"></div>
        </div>
      </div> -->
      
      <!-- 协议内容区域 -->
      <div class="content-wrapper" ref="contentRef" @scroll="handleScroll">
        <div class="content" v-html="content"></div>
      </div>
      
      <!-- 底部确认按钮 -->
      <div class="popup-footer">
        <van-button
          block
          :disabled="!canConfirm"
          :color="canConfirm ? 'linear-gradient(to right, #5DD682, #5AFF8E)' : '#ccc'"
          @click="handleConfirm"
        >
          {{ canConfirm ? '我已阅读并同意' : '请先阅读完毕' }}{{!canConfirm?'（剩余 '+ countdown +' 秒）':''}}
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'AgreementPopup',
  props: {
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: '用户协议'
    },
    // 协议内容（HTML格式）
    content: {
      type: String,
      default: ''
    },
    // 强制阅读时间（秒）
    readTime: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      showPopup: false,
      countdown: 0,
      hasScrolledToBottom: false,
      timer: null
    };
  },
  computed: {
    // 计算进度条宽度
    progressWidth() {
      return ((this.readTime - this.countdown) / this.readTime) * 100;
    },
    // 是否可以确认
    canConfirm() {
      return this.countdown <= 0 && this.hasScrolledToBottom;
    }
  },
  watch: {
    value(val) {
      this.showPopup = val;
      if (val) {
        this.resetState();
        this.startCountdown();
      } else {
        this.clearTimer();
      }
    },
    showPopup(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    // 重置状态
    resetState() {
      this.countdown = this.readTime;
      this.hasScrolledToBottom = false;
      this.$nextTick(() => {
        if (this.$refs.contentRef) {
          this.$refs.contentRef.scrollTop = 0;
        }
      });
    },
    // 开始倒计时
    startCountdown() {
      this.clearTimer();
      this.countdown = this.readTime;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearTimer();
        }
      }, 1000);
    },
    // 清除定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 处理滚动
    handleScroll() {
      const el = this.$refs.contentRef;
      if (!el) return;
      
      // 允许少量误差（5px以内）
      const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 5;
      if (isAtBottom && !this.hasScrolledToBottom) {
        this.hasScrolledToBottom = true;
      }
    },
    // 关闭弹窗
    handleClose() {
      this.showPopup = false;
      this.$emit('close');
    },
    // 确认
    handleConfirm() {
      if (!this.canConfirm) return;
      this.showPopup = false;
      this.$emit('confirm');
    }
  },
  beforeDestroy() {
    this.clearTimer();
  }
};
</script>

<style lang="scss" scoped>
.agreement-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  
  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;
    
    h3 {
      margin: 0;
      font-size: 16px;
      color: #333;
    }
    
    .van-icon {
      font-size: 20px;
      color: #999;
    }
  }
  
  .read-timer {
    padding: 12px 16px;
    background: #f5f5f5;
    
    .timer-text {
      display: block;
      font-size: 13px;
      color: #666;
      margin-bottom: 8px;
    }
    
    .timer-progress {
      height: 4px;
      background: #e0e0e0;
      border-radius: 2px;
      overflow: hidden;
      
      .timer-bar {
        height: 100%;
        background: linear-gradient(to right, #5DD682, #5AFF8E);
        border-radius: 2px;
        transition: width 1s linear;
      }
    }
  }
  
  .content-wrapper {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    -webkit-overflow-scrolling: touch;
    
    .content {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      word-break: break-all;
    }
  }
  
  .popup-footer {
    padding: 16px;
    border-top: 1px solid #eee;
    
    .van-button {
      border-radius: 22px;
      font-size: 16px;
    }
  }
}
</style>
